import React from "react";
import "./rsvpfooter.css";

const Rsvpfooter = ({ details, isPreview }) => {
  const hasRvspContent=details?.rsvp?.heading
  const rsvp = details?.rsvp;
  const hasRsvp = !!hasRvspContent;
  const contacts = rsvp?.contacts || [];

  const envelopeImages = {
  theme1:
    "https://res.cloudinary.com/depixc8dq/image/upload/v1785009119/aamantran%20assets/envelope-cropped_ipuey6.png",

  theme2:
    "https://res.cloudinary.com/depixc8dq/image/upload/v1787592879/aamantran%20assets/theme-2-env_vy2je6.png",

  // Add more themes here
  theme3:
    "https://res.cloudinary.com/depixc8dq/image/upload/v1787991456/aamantran%20assets/theme3-footerenvelope_fxojap.png",

  theme4:
    "https://res.cloudinary.com/depixc8dq/image/upload/v1788968501/aamantran%20assets/theme4-envelope_xp7nkw.png",

    theme5:
    "https://res.cloudinary.com/depixc8dq/image/upload/v1791263482/aamantran%20assets/floral-2_theme_envelope_l0mvji.png"
};

const defaultEnvelope =
  "https://res.cloudinary.com/depixc8dq/image/upload/v1785009119/aamantran%20assets/envelope-cropped_ipuey6.png";

    const envelopeImage =
    envelopeImages[details?.theme] || defaultEnvelope;




  return (
    <>
      <section  className={`rsvp-footer-section ${details?.theme || ''}`} >

        <div className="rsvp-envelope" data-aos="fade-up">

           <img
          src={envelopeImage}
            alt="footer-env"
          />

<div className={`rsvp-safe ${!hasRsvp ? "rsvp-empty-state" : ""}`} >

  {hasRsvp ? (

    <div className="rsvp-content">

      <h3 className="rsvp-heading">
        {rsvp.heading}
      </h3>

      {rsvp.subHeading && (
        <p className="rsvp-subtitle">
          {rsvp.subHeading}
        </p>
      )}

      <div className="rsvp-contact-list">

        {contacts.map((item, index) => (

          <div
            className="rsvp-contact"
            key={index}
          >

            <span className="contact-name">
              {item.name}
            </span>

            {item.phone && (
              <a
                href={`tel:${item.phone}`}
                className="contact-phone"
                aria-label={`Call ${item.name}`}
              >
                {item.phone}
              </a>
            )}

          </div>

        ))}

      </div>

    </div>

  ) : (

    isPreview ? (

      <div className="rsvp-empty-content rsvp-preview-empty">

        <h3 className="rsvp-empty-heading">
          RSVP
          <span>DETAILS</span>
        </h3>

        <p className="rsvp-empty-subtitle">
          Add RSVP or contact details to display them here.
        </p>

      </div>

    ) : (

      <div className="rsvp-empty-content">

        <h3 className="rsvp-empty-heading">
          UNTIL
          <span>WE</span>
          MEET
        </h3>

        <p className="rsvp-empty-subtitle">
          We look forward to celebrating with you.
        </p>

      </div>

    )

  )}

</div>
        </div>

      </section>

      <footer className={`branding-footer ${details?.theme || ''}`} >
        Made with{" "}
        <a
          href="https://aamantraninvites.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Aamantran Invites
        </a>
      </footer>
    </>
  );
};

export default Rsvpfooter;